import React from 'react';
import { LanyardButtonProps } from '../Contentful/transformers/ButtonTransformer';
import Button from '@jbhi-fi/lanyard-ui/components/Button/Button';
import { styles } from './ButtonBlock.css';

export interface ButtonBlockProps {
  alignment: 'Left' | 'Centred';
  buttons: Array<LanyardButtonProps>;
}

export const ButtonBlock = ({ buttons, alignment }: ButtonBlockProps) => {
  const isCentred = alignment === 'Centred';
  if (!buttons?.length) return null;
  return (
    <div className={styles.buttonContainer({ isCentred })}>
      {buttons.map((button, index) => (
        <Button key={index} {...button}></Button>
      ))}
    </div>
  );
};
